import { render, staticRenderFns } from "./LButton.vue?vue&type=template&id=3cc011f8"
import script from "./LButton.vue?vue&type=script&lang=js"
export * from "./LButton.vue?vue&type=script&lang=js"
import style0 from "./LButton.vue?vue&type=style&index=0&id=3cc011f8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports